import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  content: {
    minWidth: "100%",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    margin: 0,
    width: "auto",
    height: "auto",
    backgroundColor: "#F1F1F1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative"
  }
});

const ContentBlock = ({ classes, children, id, className = "" }) => (
  <div className={`${classes.content} ${className}`} id={id}>
    {children}
  </div>
);

ContentBlock.propTypes = {
  classes: PropTypes.object,
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

export default injectSheet(styles)(ContentBlock);



// WEBPACK FOOTER //
// ./src/components/ContentBlock.jsx